// Shared org-admin types — used by both LexPortal and LexIDE
/**
 * Resolve the invitation status to display for a user, applying the
 * legacy-user carve-out from the invitation-flow plan §Migration:
 * pre-Phase-1 users have a real `clerkUserId` but no `invitationStatus`
 * field — they're already onboarded, so display them as "accepted".
 *
 * Returns `undefined` for genuinely-no-invitation users (no clerkUserId,
 * no invitationStatus) so the badge can render an em-dash.
 */
export function effectiveInvitationStatus(user) {
    if (user.invitationStatus)
        return user.invitationStatus;
    if (user.clerkUserId)
        return "accepted"; // legacy: bound Clerk identity ⇒ onboarded
    return undefined;
}
export const MATTER_TYPES = [
    "civil",
    "labor",
    "tax",
    "contract",
    "advisory",
    "corporate",
    "realestate",
    "compliance",
    "other",
];
export const ASSIGNMENT_ROLES = [
    "LEAD",
    "HANDLER",
    "CONTRIBUTOR",
    "OBSERVER",
];
//# sourceMappingURL=org-admin.js.map